"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMetadataMapMap = exports.setMetadataMapSet = exports.setMetadataMap = exports.removeFromMetadata = exports.mergeWithMetadata = exports.addToMetadata = exports.getMetadataKeys = exports.getOwnMetadata = exports.getMetadata = exports.clearMetadata = exports.setMetadata = exports.hasMetadata = void 0;
require("reflect-metadata");
const utilities_1 = require("@rxap/utilities");
function hasMetadata(metadataKey, target, propertyKey) {
    return Reflect.hasMetadata(metadataKey, target, propertyKey);
}
exports.hasMetadata = hasMetadata;
function setMetadata(metadataKey, metadataValue, target, propertyKey) {
    Reflect.defineMetadata(metadataKey, metadataValue, target, propertyKey);
}
exports.setMetadata = setMetadata;
function clearMetadata(metadataKey, target, propertyKey) {
    Reflect.deleteMetadata(metadataKey, target, propertyKey);
}
exports.clearMetadata = clearMetadata;
function getMetadata(metadataKey, target, propertyKey) {
    return Reflect.getMetadata(metadataKey, target, propertyKey) || null;
}
exports.getMetadata = getMetadata;
function getOwnMetadata(metadataKey, target, propertyKey) {
    return Reflect.getOwnMetadata(metadataKey, target, propertyKey) || null;
}
exports.getOwnMetadata = getOwnMetadata;
function getMetadataKeys(target, propertyKey) {
    return Reflect.getMetadataKeys(target, propertyKey);
}
exports.getMetadataKeys = getMetadataKeys;
function addToMetadata(metadataKey, metadataValue, target, propertyKey) {
    if (!hasMetadata(metadataKey, target, propertyKey)) {
        setMetadata(metadataKey, [], target, propertyKey);
    }
    const metadata = getMetadata(metadataKey, target, propertyKey) || [];
    setMetadata(metadataKey, [...metadata, metadataValue].filter((0, utilities_1.unique)()), target, propertyKey);
}
exports.addToMetadata = addToMetadata;
function mergeWithMetadata(metadataKey, metadataValue, target, propertyKey) {
    if (!hasMetadata(metadataKey, target, propertyKey)) {
        setMetadata(metadataKey, {}, target, propertyKey);
    }
    const metadata = getMetadata(metadataKey, target, propertyKey) || {};
    setMetadata(metadataKey, (0, utilities_1.deepMerge)(metadata, metadataValue), target, propertyKey);
}
exports.mergeWithMetadata = mergeWithMetadata;
function removeFromMetadata(metadataKey, metadataValue, target, propertyKey, isEqual = (a, b) => a === b) {
    const metadata = getMetadata(metadataKey, target, propertyKey) || [];
    setMetadata(metadataKey, metadata.filter(value => !isEqual(value, metadataValue)), target, propertyKey);
}
exports.removeFromMetadata = removeFromMetadata;
function setMetadataMap(key, value, metadataKey, target, propertyKey) {
    let map = getOwnMetadata(metadataKey, target, propertyKey);
    if (!map) {
        const parentMap = getMetadata(metadataKey, target, propertyKey);
        if (parentMap) {
            map = new Map(parentMap.entries());
        }
        else {
            map = new Map();
        }
    }
    map.set(key, value);
    setMetadata(metadataKey, map, target, propertyKey);
}
exports.setMetadataMap = setMetadataMap;
function setMetadataMapSet(key, value, metadataKey, target, propertyKey) {
    let map = getOwnMetadata(metadataKey, target, propertyKey);
    if (!map) {
        const parentMap = getMetadata(metadataKey, target, propertyKey);
        if (parentMap) {
            map = new Map(parentMap.entries());
        }
        else {
            map = new Map();
        }
    }
    if (!map.has(key)) {
        map.set(key, new Set());
    }
    const set = map.get(key);
    set.add(value);
    setMetadata(metadataKey, map, target, propertyKey);
}
exports.setMetadataMapSet = setMetadataMapSet;
function setMetadataMapMap(key, key2, value, metadataKey, target, propertyKey) {
    let map = getOwnMetadata(metadataKey, target, propertyKey);
    if (!map) {
        const parentMap = getMetadata(metadataKey, target, propertyKey);
        if (parentMap) {
            map = new Map(parentMap.entries());
        }
        else {
            map = new Map();
        }
    }
    if (!map.has(key)) {
        map.set(key, new Map());
    }
    const innerMap = map.get(key);
    innerMap.set(key2, value);
    setMetadata(metadataKey, map, target, propertyKey);
}
exports.setMetadataMapMap = setMetadataMapMap;
